import PromoBlock from './PromoBlock.jsx'

export default PromoBlock
